import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(showLoaderSagaWorker),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(showLoaderSagaWatcher),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(hideLoaderSagaWorker),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(hideLoaderSagaWatcher),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(increaseRequestCounterSagaWorker),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(increaseRequestCounterSagaWatcher),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(decreaseRequestCounterSagaWorker),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(decreaseRequestCounterSagaWatcher),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(loaderSaga);

import { all, fork, put, takeLatest } from 'redux-saga/effects';
import { INIT_LOADER_HIDING, INIT_LOADER_SHOWING, INIT_REQUEST_COUNTER_DECREASING, INIT_REQUEST_COUNTER_INCREASING } from './loader.action-types';
import { actions } from './loader.actions';
/**
 * Show loader saga worker.
 *
 * @author Mikhail Siutsou
 * @function showLoaderSagaWorker
 * @category Sagas
 * @subcategory Loader
 * @return {Generator<PutEffect>} action data.
 */

function showLoaderSagaWorker() {
  return _regeneratorRuntime.wrap(function showLoaderSagaWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(actions.showLoader());

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * Show loader saga watcher.
 *
 * @author Mikhail Siutsou
 * @function showLoaderSagaWatcher
 * @category Sagas
 * @subcategory Loader
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function showLoaderSagaWatcher() {
  return _regeneratorRuntime.wrap(function showLoaderSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeLatest(INIT_LOADER_SHOWING, showLoaderSagaWorker)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * Hide loader saga worker.
 *
 * @author Mikhail Siutsou
 * @function hideLoaderSagaWorker
 * @category Sagas
 * @subcategory Loader
 * @return {Generator<PutEffect>} action data.
 */


function hideLoaderSagaWorker() {
  return _regeneratorRuntime.wrap(function hideLoaderSagaWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put(actions.hideLoader());

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
/**
 * Hide laoder saga watcher.
 *
 * @author Mikhail Siutsou
 * @function hideLoaderSagaWatcher
 * @category Sagas
 * @subcategory Loader
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function hideLoaderSagaWatcher() {
  return _regeneratorRuntime.wrap(function hideLoaderSagaWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return all([takeLatest(INIT_LOADER_HIDING, hideLoaderSagaWorker)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
/**
 * Increase request counter saga worker.
 *
 * @author Mikhail Siutsou
 * @function hideLoaderSagaWorker
 * @category Sagas
 * @subcategory Loader
 * @return {Generator<PutEffect>} action data.
 */


function increaseRequestCounterSagaWorker() {
  return _regeneratorRuntime.wrap(function increaseRequestCounterSagaWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return put(actions.increaseRequestCounter());

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
/**
 * Increase request counter saga watcher.
 *
 * @author Mikhail Siutsou
 * @function increaseRequestCounterSagaWatcher
 * @category Sagas
 * @subcategory Loader
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function increaseRequestCounterSagaWatcher() {
  return _regeneratorRuntime.wrap(function increaseRequestCounterSagaWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return all([takeLatest(INIT_REQUEST_COUNTER_INCREASING, increaseRequestCounterSagaWorker)]);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
/**
 * Decrease request counter saga worker.
 *
 * @author Mikhail Siutsou
 * @function decreaseRequestCounterSagaWorker
 * @category Sagas
 * @subcategory Loader
 * @return {Generator<PutEffect>} action data.
 */


function decreaseRequestCounterSagaWorker() {
  return _regeneratorRuntime.wrap(function decreaseRequestCounterSagaWorker$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return put(actions.decreaseRequestCounter());

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
/**
 * Decrease request counter saga watcher.
 *
 * @author Mikhail Siutsou
 * @function increaseRequestCounterSagaWatcher
 * @category Sagas
 * @subcategory Loader
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function decreaseRequestCounterSagaWatcher() {
  return _regeneratorRuntime.wrap(function decreaseRequestCounterSagaWatcher$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return all([takeLatest(INIT_REQUEST_COUNTER_DECREASING, decreaseRequestCounterSagaWorker)]);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}
/**
 * Loader saga.
 *
 * @author Mikhail Siutsou
 * @function loaderSaga
 * @category Sagas
 * @subcategory Loader
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


export default function loaderSaga() {
  return _regeneratorRuntime.wrap(function loaderSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return all([fork(showLoaderSagaWatcher), fork(hideLoaderSagaWatcher), fork(increaseRequestCounterSagaWatcher), fork(decreaseRequestCounterSagaWatcher)]);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}